var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Table", {
        ref: "standPaginationTable",
        attrs: {
          columns: _vm.columns,
          data: _vm.data,
          loading: _vm.loading,
          size: _vm.size,
          border: true,
          stripe: true,
          height: _vm.tableHeight,
        },
        on: {
          "on-select": _vm.onSelect,
          "on-selection-change": _vm.onSelectionChange,
          "on-row-dblclick": _vm.onrowdblclick,
          "on-sort-change": _vm.onSortChange,
        },
      }),
      _vm.showPage
        ? _c("Page", {
            staticClass: "page",
            attrs: {
              total: _vm.tableSearch.limit.conditions.total,
              "page-size": _vm.tableSearch.limit.conditions.pageLength,
              current: _vm.tableSearch.limit.conditions.pageStart,
              "page-size-opts": _vm.pageSizeOptions,
              size: "small",
              "show-elevator": "",
              "show-sizer": "",
              "show-total": "",
              placement: "top",
            },
            on: {
              "on-change": _vm.tablePageOnChange,
              "on-page-size-change": _vm.tablePageOnSizeChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }